import HomeEquipmentsPage from './HomeEquipmentsPage.vue';
import { installSharedRuntimeBridges, mountVuePage } from '@/main';

let isInstalled = false;

/**
 * 安裝 home-equipments 入口所需 runtime
 */
const installHomeEquipmentsRuntime = (): void => {
    if (isInstalled) return;

    installSharedRuntimeBridges();
    isInstalled = true;
};

installHomeEquipmentsRuntime();

mountVuePage({
    selector: '#HomeEquipmentsPageApp',
    appKey: 'home-equipments-page',
    render: (h) => h(HomeEquipmentsPage),
});
